import { globals, page as pageIndex } from "../../globals";
import { showModal, hideModal } from "./modal";
import {
  GET_LOCALITIES_BY_STATE_START,
  GET_LOCALITIES_BY_STATE_SUCCESS,
  GET_LOCALITIES_BY_STATE_FAILURE,
  GET_COUNTRY_REGIONS_FETCHED,
  GET_ALL_REGIONS_FETCHED,
} from "./regions";
import { actionHandler, UPDATE_DATA } from "./updateData";
import { logOut } from "./auth";
import { sortAlphabetical } from "./helpers";
// ------------------------------------
// Constants
// ------------------------------------
export const GET_LOCALITIES_BY_CLIENT_START = "GET_LOCALITIES_BY_CLIENT_START";
export const GET_LOCALITIES_BY_CLIENT_SUCCESS =
  "GET_LOCALITIES_BY_CLIENT_SUCCESS";
export const GET_LOCALITIES_BY_CLIENT_FAILURE =
  "GET_LOCALITIES_BY_CLIENT_FAILURE";
export const CREATE_CLIENT_LOCALITY_START = "CREATE_CLIENT_LOCALITY_START";
export const CREATE_CLIENT_LOCALITY_SUCCESS = "CREATE_CLIENT_LOCALITY_SUCCESS";
export const CREATE_CLIENT_LOCALITY_FAILURE = "CREATE_CLIENT_LOCALITY_FAILURE";
export const DELETE_CLIENT_LOCALITY_START = "DELETE_CLIENT_LOCALITY_START";
export const DELETE_CLIENT_LOCALITY_SUCCESS = "DELETE_CLIENT_LOCALITY_SUCCESS";
export const DELETE_CLIENT_LOCALITY_FAILURE = "DELETE_CLIENT_LOCALITY_FAILURE";
export const GET_LIST_OF_CLIENTS_START = "GET_LIST_OF_CLIENTS_START";
export const GET_LIST_OF_CLIENTS_SUCCESS = "GET_LIST_OF_CLIENTS_SUCCESS";
export const GET_LIST_OF_CLIENTS_FAILURE = "GET_LIST_OF_CLIENTS_FAILURE";
export const FILTER_CLIENT_LOCALITIES = "FILTER_CLIENT_LOCALITIES";
export const GET_LOCALITY_HISTORY_START = "GET_LOCALITY_HISTORY_START";
export const GET_LOCALITY_HISTORY_SUCCESS = "GET_LOCALITY_HISTORY_SUCCESS";
export const GET_LOCALITY_HISTORY_FAILURE = "GET_LOCALITY_HISTORY_FAILURE";
// ------------------------------------
// Actions
// ------------------------------------
const headers = {
  "Content-Type": "application/json",
};

export function getLocalitiesByClient(clientName) {
  return (dispatch) => {
    dispatch({ type: GET_LOCALITIES_BY_CLIENT_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    const clientLocalityURL = clientName ? `?clientname=${clientName}` : "";
    fetch(`${globals.apiUrl}/clientlocality${clientLocalityURL}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCALITIES_BY_CLIENT_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCALITIES_BY_CLIENT_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCALITIES_BY_CLIENT_FAILURE, json: err });
      });
  };
}

export function createClientLocality(localityClientObj) {
  return (dispatch) => {
    dispatch({ type: CREATE_CLIENT_LOCALITY_START });
    const options = {
      method: "POST",
      credentials: "include",
      headers,
      body: JSON.stringify(localityClientObj),
    };
    fetch(`${globals.apiUrl}/clientlocality`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: CREATE_CLIENT_LOCALITY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: CREATE_CLIENT_LOCALITY_SUCCESS,
            payload: {
              json,
            },
          });
          dispatch(hideModal("Add-new-item-client-locality"));
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: CREATE_CLIENT_LOCALITY_FAILURE, json: err });
      });
  };
}

export function deleteClientLocality(localityId) {
  return (dispatch) => {
    dispatch({ type: DELETE_CLIENT_LOCALITY_START });
    const options = {
      method: "DELETE",
      credentials: "include",
      headers,
    };
    fetch(`${globals.apiUrl}/clientlocality/${localityId}`, options).then(
      (response) => {
        if (response.status === 200) {
          dispatch({
            type: DELETE_CLIENT_LOCALITY_SUCCESS,
            localityId,
          });
          dispatch(hideModal("Delete-client-locality"));
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: DELETE_CLIENT_LOCALITY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      }
    );
  };
}

function returnLocalities(localities) {
  return localities.map((item) => {
    return {
      value: item.LocalReviewId,
      label: item.Locality,
    };
  });
}

export function getListOfClients(isActive, searchType, serviceLevel) {
  return (dispatch) => {
    dispatch({ type: GET_LIST_OF_CLIENTS_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    fetch(
      `${globals.apiUrl}/client?active=${isActive}&searchtype=${searchType}&servicelevel=${serviceLevel}`,
      options
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LIST_OF_CLIENTS_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LIST_OF_CLIENTS_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LIST_OF_CLIENTS_FAILURE, json: err });
      });
  };
}

function returnClients(clients) {
  return clients.map((item) => {
    return {
      value: item.Id,
      label: item.Name,
    };
  });
}

function returnLocalitiesForSelectedClient(localities, clientL) {
  const clientLocalities = clientL.map((item) => item.Locality);
  if (localities) {
    return localities.filter((item) => clientLocalities.includes(item.label));
  } else return clientL;
}

export function filterClientLocalities(locality) {
  return {
    type: FILTER_CLIENT_LOCALITIES,
    locality,
  };
}

function sortByLocality(localities) {
  return localities.sort(function (a, b) {
    if (`${a["Client"]} ${a["Locality"]}` < `${b["Client"]} ${b["Locality"]}`) {
      return -1;
    }
    if (`${a["Client"]} ${a["Locality"]}` > `${b["Client"]} ${b["Locality"]}`) {
      return 1;
    }
    return 0;
  });
}

export function getLocalitiesHistory(searchOptions) {
  return (dispatch) => {
    dispatch({ type: GET_LOCALITY_HISTORY_START });
    const options = {
      method: "GET",
      credentials: "include",
      headers,
    };
    const setSearchOptions = searchOptions
      ? `?search=${searchOptions.split(" ").join("*")}`
      : "";
    fetch(`${globals.apiUrl}/clientlocalityhistory${setSearchOptions}`, options)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({ type: GET_LOCALITY_HISTORY_FAILURE, json: text });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((json) => {
        if (json) {
          dispatch({
            type: GET_LOCALITY_HISTORY_SUCCESS,
            payload: {
              json,
            },
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: GET_LOCALITY_HISTORY_FAILURE, json: err });
      });
  };
}
// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_LOCALITIES_BY_CLIENT_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LOCALITIES_BY_CLIENT_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        clientLocalitiesAll: json,
        clientLocalities: sortByLocality(json),
        localities: [
          { label: "All Localities", value: "*" },
          ...returnLocalitiesForSelectedClient(
            state.renderData.allLocalities,
            json
          ),
        ],
      },
    };
  },
  [GET_LOCALITIES_BY_CLIENT_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json,
    };
  },
  [CREATE_CLIENT_LOCALITY_START]: (state) => {
    return {
      ...state,
    };
  },
  [CREATE_CLIENT_LOCALITY_SUCCESS]: (state, action) => {
    const { json } = action.payload;
    let newLocalities = state.renderData.clientLocalities;
    const clientValue = state.formDataValue.CLS.queryLine.radio.client;
    const clientName = state.renderData.clientsListAll.find(
      (item) => item.label === json.Client
    );
    if (clientValue === clientName.value || clientValue === "*") {
      newLocalities = sortAlphabetical(
        [...state.renderData.clientLocalities, json],
        "Locality"
      );
    }
    const localityValue = state.formDataValue.CLS.queryLine.radio.locality;
    let filteredLocalities = [];
    if (localityValue !== "*") {
      filteredLocalities = newLocalities.filter(
        (item) => item.Locality === localityValue
      );
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        newClientLocality: json,
        clientLocalities:
          localityValue !== "*"
            ? sortByLocality(filteredLocalities)
            : sortByLocality(newLocalities),
        clientLocalitiesAll: [...state.renderData.clientLocalitiesAll, json],
      },
      formDataValue: {
        CLS: {
          ...state.formDataValue.CLS,
          newLocality: {
            radio: {
              state: "",
              locality: "",
              client: "",
            },
          },
        },
      },
    };
  },
  [CREATE_CLIENT_LOCALITY_FAILURE]: (state, action) => {
    const { json } = action;
    return {
      ...state,
      errorCode: json,
      renderData: {
        ...state.renderData,
      },
    };
  },
  [DELETE_CLIENT_LOCALITY_START]: (state) => {
    return {
      ...state,
    };
  },
  [DELETE_CLIENT_LOCALITY_SUCCESS]: (state, action) => {
    const { localityId } = action;
    return {
      ...state,
      renderData: {
        ...state.renderData,
        deleted: localityId,
        clientLocalities: state.renderData.clientLocalities.filter(
          (item) => item.Id !== localityId
        ),
      },
    };
  },
  [DELETE_CLIENT_LOCALITY_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json,
    };
  },
  [GET_LOCALITIES_BY_STATE_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_LOCALITIES_BY_STATE_SUCCESS]: (state, action) => {
    const { json, stateId } = action.payload;
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        allLocalities:
          stateId === "*"
            ? [
                { label: "All Localities", value: "*" },
                ...returnLocalities(json),
              ]
            : state.renderData.allLocalities,
        localitiesByState: stateId === "*" ? [] : returnLocalities(json),
        localities:
          stateId === "*"
            ? [
                { label: "All Localities", value: "*" },
                ...returnLocalities(json),
              ]
            : state.renderData.allLocalities,
      },
    };
  },
  [GET_LOCALITIES_BY_STATE_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json,
    };
  },
  [GET_COUNTRY_REGIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        clientStates: action.payload.json.map((item) => {
          return {
            value: item.ShortName,
            label: item.Name,
          };
        }),
      },
    };
  },
  [GET_ALL_REGIONS_FETCHED]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        clientStates: action.payload.json.map((item) => {
          return {
            value: item.ShortName,
            label: item.Name,
          };
        }).filter((elem) => {
          return elem.label !== "All States" 
            && elem.label !== "Canada"
            && elem.label !== "Spain"
        }),
      },
    };
  },
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.clientLocalities
      ? state
      : actionHandler(state, action),
  [GET_LIST_OF_CLIENTS_START]: (state) => {
    return {
      ...state,
      isFetchingData: true,
    };
  },
  [GET_LIST_OF_CLIENTS_SUCCESS]: (state, action) => {
    const clients = [
      { value: "*", label: "All Clients" },
      ...returnClients(action.payload.json),
    ];
    return {
      ...state,
      isFetchingData: false,
      renderData: {
        ...state.renderData,
        clientsListAll: clients,
        clientsList: clients,
      },
    };
  },
  [GET_LIST_OF_CLIENTS_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json,
    };
  },
  [FILTER_CLIENT_LOCALITIES]: (state, action) => {
    let clientLocalities;
    let clientsList;
    const selectedLocality = state.renderData.allLocalities.find(
      (item) => item.value === action.locality
    );
    if (action.locality !== "*") {
      clientLocalities = state.renderData.clientLocalitiesAll.filter(
        (item) => item.Locality === selectedLocality.label
      );
    } else {
      clientLocalities = state.renderData.clientLocalitiesAll;
    }
    if (
      state.formDataValue.CLS.queryLine.radio.client ||
      action.locality === "*"
    ) {
      clientsList = state.renderData.clientsListAll;
    } else {
      const clients = state.renderData.clientLocalitiesAll
        .filter((item) => item.Locality === selectedLocality.label)
        .map((item) => item.Client);
      clientsList = state.renderData.clientsListAll.filter((item) =>
        clients.includes(item.label)
      );
    }
    return {
      ...state,
      renderData: {
        ...state.renderData,
        clientLocalities,
        clientsList,
      },
    };
  },
  [GET_LOCALITY_HISTORY_START]: (state) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        localitiesHistory: undefined,
      },
    };
  },
  [GET_LOCALITY_HISTORY_SUCCESS]: (state, action) => {
    return {
      ...state,
      renderData: {
        ...state.renderData,
        localitiesHistory: action.payload.json,
      },
    };
  },
  [GET_LOCALITY_HISTORY_FAILURE]: (state, action) => {
    return {
      ...state,
      isFetchingData: false,
      errorCode: action.json,
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isFetchingData: false,
  errorCode: "",
  renderData: {},
  formDataValue: {
    CLS: {
      queryLine: {
        radio: {
          client: "*",
          locality: "*",
        },
      },
      newLocality: {
        radio: {
          state: "",
          locality: "",
          client: "",
        },
      },
    },
  },
};
export default function clientLocalitiesReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/clientLocalities.js